import { defineStore } from 'pinia'
import { gameGroupList } from '@/server/game_group'

/**
 * 定义分组store
 */
interface IGameGroupParam {
  id: string
  name: string
}
interface IStateParam {
  gameGroup: IGameGroupParam[]
}

export const useGameGroupStore = defineStore('gameStore', {
  state: (): IStateParam => {
    return {
      gameGroup: []
    }
  },
  actions: {
    getGameGroup() {
      gameGroupList({}).then((res) => {
        if (res && res.code == '0') {
          //@ts-ignore
          this.gameGroup = res.data ? res.data : []
        }
      })
    },
    setGroup(value: any) {
      this.gameGroup = value
    }
  }
})
